<template>
  <div class="chat-textarea">
    <div class="question" v-if="!!question">
      {{question}}
    </div>
    <div class="examples" v-if="!!examples">
      {{examples}}
    </div>
    <div class="textarea-wrapper">
      <textarea :value="value" @input="onInput" ref="textarea" :placeholder="placeholder" />
      <template v-if="!value&&!!maskPlaceholder">
        <div class="mask" v-if="showMask" @click="onClick">{{maskPlaceholder}}</div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    question: {
      type: String,
      default: ''
    },
    examples: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    maskPlaceholder: {
      type: String,
      default: '点击输入我的回答'
    }
  },
  data () {
    return {
      showMask: true,
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value)
    },
    onClick() {
      this.showMask = false
      this.$refs.textarea.focus()
    }
  }
}


</script>

<style scoped lang="scss">
.chat-textarea{
  width: 100%;
}
.question {
  box-sizing: border-box;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  margin-bottom: 10px;
}
.examples {
  box-sizing: border-box;
  font-size: 12px;
  padding: 0 12px;
  font-weight: 400;
  line-height: 17.38px;
  color: rgba(121, 72, 234, 0.4);
  margin-bottom: 10px;
}
.textarea-wrapper {
  position: relative;
  width: 100%;
  border-radius: 17px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    height: 69px;
    font-size: 10px;
    font-weight: 300;
    line-height: 14.48px;
    text-align: left;
    border: none;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    font-weight: 300;
    line-height: 14.48px;
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>